export default "__VITE_ASSET__DdUUYAt5__"